'use strict';

var translations = {
    warnings: {
        straightRow: 'Vermeide gerade Tastenreihen wie "asdf".',
        simpleRepeat: 'Vermeide wiederholte Wörter und Zeichen wie "aaa" und "abcabc".',
        extendedRepeat: 'Vermeide wiederholte Wörter und Zeichen wie "aaa" und "abcabc".',
        sequences: 'Vermeide Sequenzen wie "abc" oder "6543".',
        recentYears: 'Vermeide aktuelle Jahreszahlen wie "2020".',
        dates: 'Vermeide Daten.',
        topTen: 'Vermeide häufige Passwörter.',
        topHundred: 'Vermeide häufige Passwörter.',
        common: 'Vermeide häufige Passwörter.',
        similarToCommon: 'Vermeide häufige Passwörter.',
        wordByItself: 'Vermeide die Verwendung eines einzelnen Wortes.',
        namesByThemselves: 'Vermeide Namen und Nachnamen allein.',
        commonNames: 'Vermeide Namen und Nachnamen allein.',

        userInputs: '',
        pwned: '',
        keyPattern: '',
    },
    suggestions: {
        useWords:
            'Verwende eine lange Zeichenfolge mit mehr als zwei Wörtern; vermeide gängige Phrasen.',
        anotherWord: 'Füge ein oder zwei weitere Wörter hinzu. Ungewöhnliche Wörter sind besser.',
        repeated: 'Vermeide wiederholte Wörter und Zeichen wie "aaa" und "abcabc".',
        l33t: 'Vermeide vorhersehbare Ersetzungen wie "@" anstelle von "a" (wie in "@pple" anstelle von "Apple").',
        reverseWords: 'Vermeide umgekehrte Wörter wie "elppa" (Umkehrung von "apple").',
        allUppercase: 'Nur Großbuchstaben sind fast so leicht zu erraten wie nur Kleinbuchstaben.',
        dates: 'Vermeide Daten.',
        associatedYears: 'Vermeide Daten.',
        recentYears: 'Vermeide aktuelle Jahreszahlen wie "2020".',
        sequences: 'Vermeide Sequenzen wie "abc" oder "6543".',

        pwned: '',
        capitalization: '',
        longerKeyboardPattern: '',
        noNeed: '',
    },
    timeEstimation: {
        ltSecond: 'weniger als eine Sekunde',
        second: '{base} Sekunde',
        seconds: '{base} Sekunden',
        minute: '{base} Minute',
        minutes: '{base} Minuten',
        hour: '{base} Stunde',
        hours: '{base} Stunden',
        day: '{base} Tag',
        days: '{base} Tage',
        month: '{base} Monat',
        months: '{base} Monate',
        year: '{base} Jahr',
        years: '{base} Jahre',
        centuries: 'Jahrhunderte',
    },
};

export default translations;
//# sourceMappingURL=translations.js.map
